import React from "react";
import { Link } from "@quintype/components";
import { string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LiveText from "../LiveText";

import "./liveNewsHeadline.m.css";

const LiveNewsHeadline = ({
  titleText = "",
  titleLink = "",
  story,
  cssStyleName,
  publisherAttributes,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  return (
    <h2 styleName={`title ${cssStyleName}`} className="headline-title">
      <Link href={titleLink} styleName="title-link">
        {isClosed ? (
          ""
        ) : (
          <LiveText
            story={story}
            lang={publisherAttributes.lang}
            data-tracking-category={datatrackingcategory}
            data-tracking-action={datatrackingaction}
            data-tracking-label={datatrackinglabel}
          />
        )}

        {titleText}
      </Link>
    </h2>
  );
};

LiveNewsHeadline.propTypes = {
  titleText: string,
  titleLink: string,
  story: object,
  cssStyleName: string,
  publisherAttributes: object,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(LiveNewsHeadline);
